import { writable, readable } from 'svelte/store'
import type { Writable, Readable } from 'svelte/store'

export const hasLocaToken: Readable<boolean> = readable((new URLSearchParams(window.location.search)).get('token') !== null)

/** Lao = lo, English = en */
export const lang: Writable<string> = writable('en', function start(set) {
  const urlParams = new URLSearchParams(window.location.search)
  const userLang = urlParams.has('user_lang') ? urlParams.get('user_lang')?.toLocaleLowerCase() : 'en'
  set(userLang!)
	return function stop() {}
})

export const isLoading: Writable<boolean> = writable(false)
